import { render } from "./ImgTextSort.vue?vue&type=template&id=25302fb6&scoped=true"
import script from "./ImgTextSort.vue?vue&type=script&lang=js"
export * from "./ImgTextSort.vue?vue&type=script&lang=js"

import "./ImgTextSort.vue?vue&type=style&index=0&id=25302fb6&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25302fb6"]])

export default __exports__